import React, { useEffect, useState } from 'react';
import { Grid, Box, Hidden } from '@material-ui/core';
import Typed from 'typed.js';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import images from '../../assets/images/images.jpg';
import AA from '../../assets/images/AA.jpg';
import bushome from '../../assets/images/bushome.png';
import featured from '../../assets/images/featured-reo-de-janeiro-brazil.jpg';
import featuredaustralia from '../../assets/images/featured-north-bondi-australia.jpg';
import featuredgermany from '../../assets/images/featured-berlin-germany.jpg';
import featuredthailand from '../../assets/images/featured-khwaeng-wat-arun-thailand.jpg';
import featureditaly from '../../assets/images/featured-rome-italy.jpg';
import featuredmaldives from '../../assets/images/featured-fuvahmulah-maldives.jpg';
import header from '../../assets/images/services-bg.jpg';
import service from '../../assets/images/header-bg.jpg';
import pngwin from '../../assets/images/pngwin.png';
import './Homepage2.css';
import test1 from '../../assets/images/test-1.jpg';
import test2 from '../../assets/images/test-2.jpg';
import test3 from '../../assets/images/avt.jpg';
import arya from '../../assets/images/arya.jpg';
import SearchFlightNew from '../../form/SearchFlightNew';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/hotelnew.svg';
import TitleText from '../../components/reusableComponents/TitleText';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import { useHistory } from 'react-router-dom';
import SearchBusNew from '../../form/SearchBusNew';
import LoaderModal from '../../components/reusableComponents/LoaderModal';
import { toggleRegisterModal } from '../../reducers/UiReducer';
import RegisterAgentModal from '../../components/reusableComponents/RegisterAgentModal';
import { fdSectorDispatch } from '../../reducers/FDReducer';
const B2BHome = () => {
	const dispatch = useDispatch();
	const [toggleFlight, setToggleFlight] = useState(true);
	const [toggleBus, setToggleBus] = useState(false);
	const { loadinguser } = useSelector((state) => state.user);
	// const el = React.useRef(null);
	// const typed = React.useRef(null);
	// React.useEffect(() => {
	// 	const options = {
	// 		strings: [
	// 			'Welcome to <strong>Musafirbazar</strong>',
	// 			'Leave Your Footprints',
	// 		],
	// 		typeSpeed: 100,
	// 		backSpeed: 100,
	// 		// loop: true,
	// 	};

	// 	typed.current = new Typed(el.current, options);
	// }, []);
	useEffect(() => {
		let form = {};
		dispatch(fetchBannerDispatch());
		dispatch(fetchCityDispatch());
		dispatch(fdSectorDispatch(form));
	}, []);
	console.log(toggleFlight);
	console.log(toggleBus);
	const history = useHistory();
	return (
		<>
			<nav className='navbar' style={{ background: 'white' }}>
				<div className='container flex'>
					<a href='' className='site-brand'>
						<img src={AA} style={{ height: 70 }}></img>
						<span
							style={{
								color: '#8b0000f2',
								fontSize: '30px',
								fontWeight: 600,
								fontFamily: 'cursive',
							}}>
							Arya Aviation
						</span>
					</a>

					<Hidden only={['xs', 'sm']}>
						<Box display='flex' alignItems='center'>
							<TitleText textStyle={{ fontSize: 24 }}>
								24x7 Agent Helpline
							</TitleText>
							<i
								class='fas fa-phone'
								style={{
									transform: 'rotate(90deg)',
									color: '#ef3339',
									fontSize: '28px',
									marginLeft: 20,
								}}></i>
							<Box onClick={() => (window.location = 'tel:887-777-3388')}>
								<TitleText textStyle={{ marginLeft: 10, fontSize: 20 }}>
									+91 887-777-3388
								</TitleText>
							</Box>

							<Box
								onClick={() => dispatch(toggleRegisterModal(true))}
								ml={'20px'}
								display='flex'
								alignItems='center'
								style={{
									background: '#ef3339',
									padding: '5px 14px',
									color: 'white',
									borderRadius: 5,
									cursor: 'pointer',
								}}>
								<i className='fas fa-user'></i>
								<TitleText textStyle={{ marginLeft: 10 }}>
									REGISTER NOW
								</TitleText>
							</Box>
						</Box>
					</Hidden>
				</div>
			</nav>
			<header
				className='flex'
				style={{
					backgroundImage: `url(${arya})`,
					zIndex: 0,
					transition: 'background-image 300ms ease-in 200ms',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
					backgroundAttachment: 'fixed',
					height: '800px',
				}}>
				{/* <Box style={{padding:10}}> */}
				<Grid container>
					<Grid item xs={12} md={6}>
						{/* <div className='header-form'>
								{toggleFlight ? <SearchFlightNew /> : <SearchBusNew />}
							
							</div> */}
					</Grid>
					<Grid item xs={12} md={6}>
						<div>
							<SearchFlightNew />
						</div>
					</Grid>
				</Grid>

				{/* <div className='header-title'>
						<h1
							ref={el}
							style={{
								fontSize: '3em',
								margin: '0.67em 0',
								textAlign: 'center',
								color: 'white',
							}}></h1>
						<p style={{ fontSize: '14px', color: 'white' }}>
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus
							rerum maxime enim odit illum in molestias beatae doloremque,
							ratione optio.
						</p>
					</div> */}
				{/* </Box> */}
			</header>
			<Grid container style={{ padding: 20, alignItems: 'center' }}>
				<Grid item xs={12} lg={4}>
					<img src='https://media.istockphoto.com/vectors/realistic-mobile-phone-mockup-template-isolated-stock-vector-vector-id1309147753?k=20&m=1309147753&s=612x612&w=0&h=bPsrHa2Jxl_gMyq0EaGvSe4t61nm_k6_D_UTr2Xfu9Q=' />
				</Grid>
				<Grid item xs={12} lg={6}>
					<h4>
						Booking Travel Services Just Got Easier with the MusafirBazar App
						Download the Latest Version TODAY
					</h4>
					<img src={images} />
				</Grid>
				<Grid item xs={2}></Grid>
			</Grid>
			<Box style={{ background: '#E61855', textAlign: 'center' }}>
				<span style={{ color: 'white' }}>
					© Copyright 2022.All Rights Reserved Version
				</span>
			</Box>
			<RegisterAgentModal />
			{loadinguser ? <LoaderModal /> : ''}
		</>
	);
};

export default B2BHome;
